




















import Vue from "vue";
import Info from "@/components/Info.vue";
import Button from "@/components/Button.vue";

export default Vue.extend({
  data() {
    return {
      enteringInfo: false,
      email: "",
      name: "",
      gotit: false,
      current: new Date(),
      target: new Date(1606003200),
      hours: 99,
      minutes: 99,
      seconds: 99,
      spad: "",
      mpad: "",
    };
  },
  components: {
    Info,
    Button,
  },
  methods: {
    handleSubmit() {
      // Changed it to use query params bc post request wasn't working, most likely due to cors errors.

      // tslint:disable-next-line
      const email_address = this.$data.email;
      // tslint:disable-next-line
      const name_input = this.$data.name;

      this.name = "";
      this.email = "";

      const params = {
        email: email_address,
        name: name_input,
      };

      this.gotit = true;
      this.enteringInfo = false;

      const esc = encodeURIComponent;
      const query = Object.keys(params)
        // @ts-ignore
        .map((k) => esc(k) + "=" + esc(params[k]))
        .join("&");
      const url =
        "https://us-central1-mydeltahacks.cloudfunctions.net/addEmailToMailchimp" +
        "?" +
        query;
      fetch(url, { mode: "cors" }).then((response) => {
        /* :) */
      });

      setTimeout(() => {
        this.gotit = false;
      }, 4000);
    },
  },
  mounted() {
    setInterval(
      () => {
        const dateFuture: Date = new Date(1606066031000);
        const dateNow: Date = new Date();

        let delta = Math.abs(dateFuture.valueOf() - dateNow.valueOf()) / 1000;

        // calculate (and subtract) whole hours
        const hours = Math.floor(delta / 3600);
        this.hours = hours;
        delta -= hours * 3600;

        // calculate (and subtract) whole minutes
        const minutes = Math.floor(delta / 60) % 60;
        this.minutes = minutes;
        this.mpad = this.minutes < 10 ? "0" : "";
        delta -= minutes * 60;

        // what's left is seconds
        const seconds = delta % 60; // in theory the modulus is not required
        this.seconds = Math.floor(seconds);
        this.spad = this.seconds < 10 ? "0" : "";
      },
      0,
      1000
    );
  },
});
